$(window).on('load resize',function(){
	let _wrapper = $('.js-kvImgWrapper')
	let _kv = $('.js-kvImg')
	let _wrapperWidth = _wrapper.width();
	let _imgWidth = _kv.width();
	let _distance = _imgWidth - _wrapperWidth;
	_kv.animate({
		right: _distance
	}, {
		duration: 10000,
		easing: 'linear'
	})
});
